import getItems from './getItems'
import getRecordByRut from './getRecordByRut'
import createEvent from './createEvent'

export const getItemsPromise = getItems
export const getRecordByRutPromise = getRecordByRut
export const createEventPromise = createEvent
